import filter from 'lodash/filter'
import flatten from 'lodash/flatten'
import uniq from 'lodash/uniq'
import sortBy from 'lodash/sortBy'
import partition from 'lodash/partition'
import intersection from 'lodash/intersection'
import { FETCH_REVENUE_CENTER_ORDERS } from './actionTypes'

export const initialState = {}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_REVENUE_CENTER_ORDERS: {
      const filtered = filter(payload.data.revenueCenters, { uuid: payload.id })
      const orderWindowNames = filtered[0]?.orderWindowNames ?? {}

      // workaround for api with multi dimension array with duplicated uuid
      const beingPrepared = filtered.map(x => x.orderConfirmationNumbers.beingPrepared)
      const ready = filtered.map(x => x.orderConfirmationNumbers.ready)
      const ordersPending = uniq(flatten(beingPrepared)).sort()
      const ordersNew = uniq(flatten(ready))
      // end of workaround

      const [ordersDoneNew, ordersDonePrev] = partition(state.ordersDone, item => item.isNew)

      const alreadyPresentOrders = uniq([
        ...ordersDoneNew.map(x => x.order),
        ...ordersDonePrev.map(x => x.order),
      ])

      const diffOrders = intersection(alreadyPresentOrders, ordersNew)

      const extractedNewOrders = ordersNew.filter(item => !alreadyPresentOrders.includes(item))

      const newOrders = extractedNewOrders.map(item => ({ order: item, isNew: true }))
      const prevOrders = diffOrders.map(item => ({ order: item, isNew: false }))
      const ordersDone = sortBy([...newOrders, ...prevOrders], 'order')

      return {
        ordersDone,
        ordersPending,
        orderWindowNames,
      }
    }

    default:
      return state
  }
}
